export const initialForms = {
    itemName:"",
    itemPrize:"",
    itemImage:""
}